// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-career/career-saved-component/career-saved-component.component.scss
// module id = 667
// module chunks = 0